// UseDocumentKeydown.tsx
import { useEffect } from "react"

/**
 * Generic hook to handle keydown events for specified keys.
 * @param {string[]} keys - Array of keys to listen for.
 * @param {Function} action - Action to perform when a key is pressed.
 * @param {boolean} condition - Condition to enable or disable the event listener.
 */
export const useDocumentKeydown = ({
    keys,
    action,
    condition
}: {
    keys: string[]
    action: () => void
    condition: boolean
}) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            try {
                if (keys.includes(event.key) && condition) {
                    action()
                }
            } catch (error) {
                console.error("Error handling keydown event:", error)
            }
        }

        document.addEventListener("keydown", handleKeyDown)

        return () => {
            document.removeEventListener("keydown", handleKeyDown)
        }
    }, [keys, action, condition]) // Include all dependencies to ensure correct behavior on updates.
}
